import React from 'react';
import { NanoInput } from '@nanoporetech-digital/components-react';

export function getDefaults(saved) {
    return {
        cup: saved?.cup ?? '',
        cig: saved?.cig ?? '',
        line_number: saved?.line_number ?? '',
        document_date: saved?.document_date ?? '',
        item_number: saved?.item_number ?? '',
        agreement_code: saved?.agreement_code ?? '',
        invoice_notes: saved?.invoice_notes ?? ''
    }
}

export default function Italy({data, update}) {
    return (
        <>
            <NanoInput
                name="line_number"
                label="Line Number (optional)"
                placeholder="Enter Line Number..."
                floatLabel={false}
                value={data.line_number}
                required={false}
                type="text"
                maxlength="4"
                showInlineError={true}
                onNanoChange={update}
            />
            <NanoInput
                name="document_date"
                label="Document Date (optional)"
                placeholder="Enter Date..."
                value={data.document_date}
                required={false}
                type="date"
                showInlineError={true}
                onNanoChange={update}
            />
            <NanoInput
                name="item_number"
                label="Item Number (optional)"
                placeholder="Enter Item Number..."
                value={data.item_number}
                required={false}
                type="text"
                maxlength="20"
                showInlineError={true}
                onNanoChange={update}
            />
            <NanoInput
                name="agreement_code"
                label="Order or Agreement Code (optional)"
                placeholder="Enter Order or Agreement Code..."
                value={data.agreement_code}
                required={false}
                type="text"
                maxlength="100"
                showInlineError={true}
                onNanoChange={update}
            />
            <NanoInput
                name="cig"
                label="CIG (optional)"
                placeholder="Enter CIG..."
                value={data.cig}
                required={false}
                type="text"
                maxlength="15"
                onNanoChange={update}
            />
            <NanoInput
                name="cup"
                label="CUP (optional)"
                placeholder="Enter CUP..."
                value={data.cup}
                required={false}
                type="text"
                maxlength="15"
                onNanoChange={update}
            />
            <NanoInput
                name="invoice_notes"
                label="Invoice Notes (optional)"
                placeholder="Enter Invoice Notes..."
                value={data.invoice_notes}
                required={false}
                type="textarea"
                maxlength="200"
                onNanoChange={update}
            >
                <span slot="helper">Please use this section to complete any additional information you would like to appear on your invoice.</span>
            </NanoInput>
        </>
    )
}
